// 1 неделя в миллисекундах (если пользователь закрыл промобар, то он не будет показан в течение 1 недели)
export const PROMO_BAR_HIDE_DURATION = 7 * 24 * 60 * 60 * 1000;

// Дата окончания промобара (31 декабря 2025, 23:59:59)
export const PROMO_BAR_END_DATE = new Date('2025-12-31T23:59:59').getTime();

export const PROMO_BAR_URL = '/community#subscriptions';
export const PROMO_BAR_STORAGE_KEY = 'promo-bar-closed';

export const promoBarData = {
	bgColor: '#DC2626',
	textColor: '#FFFFFF',
	title: '🎄 Новогодний тариф',
	description: 'Скидка 50% на доступ к платформе только до 31 декабря',
	ctaLabel: 'Забрать скидку',
};
